import { BrowserRouter } from 'react-router-dom';
import Layout from './components/Layout';
import BondContractsContextProvider from './contexts/BondContractContext/provider';
import MarketsProvider from './contexts/MarketsContext/provider';
import BondPeripheryContextProvider from './contexts/BondPeripheryContext/provider';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConnectWalletModalProvider, createAirdaoConfigWithChainId } from '@airdao/ui-library';

const queryClient = new QueryClient();

const { REACT_APP_WC_PROJECT_ID: projectId, REACT_APP_CHAIN_ID: chainId } =
  process.env;

if (!projectId || !chainId) {
  throw new Error("Missing REACT_APP_WC_PROJECT_ID or REACT_APP_CHAIN_ID");
}

const WC_PARAMS = {
  projectId: projectId,
  metadata: {
    name: "Kosmos",
    description: "Bond Marketplace",
    url: "https://star-fleet.io/kosmos/marketplace/",
    icons: ["https://star-fleet.io/kosmos/marketplace/favicon.svg"]
  },
};

const config = createAirdaoConfigWithChainId(+chainId, WC_PARAMS);

function App() {
  console.log(asciiArt);
  return (
    <WagmiProvider config={config} reconnectOnMount={false}>
      <QueryClientProvider client={queryClient}>
        <ConnectWalletModalProvider>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <BondContractsContextProvider>
              <BondPeripheryContextProvider>
                <MarketsProvider>
                  <Layout />
                </MarketsProvider>
              </BondPeripheryContextProvider>
            </BondContractsContextProvider>
          </BrowserRouter>
        </ConnectWalletModalProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;

const asciiArt = `
                   ,lc,..                                                      
                    'cx0K0xoc,..                                                
                       .;o0WMWX0xoc,..                                          
                          .cOWMMMMMWX0xolc,..                                   
                            .lXMMMMMMMMMMMWX0koc,..                             
                              :XMMMMMMMMMMMMMMMMWX0koc,..                       
                              .dWMMMMMMMMMMMMMMMMMMMMMWX0ko;                    
                               oWMMMMMMMMMMMMMMMMMMMMMMMWN0o.                   
                              'OMMMMMMMMMMMMMMMMMMWN0kdc;..                     
                             'kWMMMMMMMMMMMMWX0kdc;..                           
                           .lKMMMMMMMWX0Okoc;..                                 
                        .,dKWMMWX0koc;..                                        
                     .:d0XX0koc;..                                              
                    ;xxoc;..                                                    
                                                                              
                                                                                
                                                                                
    10001      1x1   1000000001    1x000000001.      10001       .100000001.
   00  x00     1x1   10       001  1x1        1x1   00  x00     10        101 
  000xxxx000   1x1   1O0xxxx001    1x1        1x1  000xxxx000   101        01
 000      000  1x1   10     1111   1x100000001x   000      000   '100000001'
 
 Developer?
 Build with us: https://airdao.io/grants
`;
